import { Box, Button, Stack } from "@mui/material";
import React from "react";
import { Color, FontStyle, Slug, SurveyButtonStyle } from "../../constants";
import { useNavigate } from "react-router-dom";

const NoApplicationsScreen = () => {
  const navigate = useNavigate();
  return (
    <Stack
      direction="column"
      sx={{
        paddingTop: "80px",
        width: "100%",
        height: "100%",
        ...FontStyle.body,
        zIndex: 1,
      }}
      alignItems="center">
      <Stack
        alignItems="center"
        direction="column"
        spacing={3}
        sx={{
          width: "100%",
          height: "100%",
          maxWidth: "600px",
        }}>
        <Box
          sx={{
            fontSize: "24px",
            fontWeight: "bold",
          }}>
          No Applications
        </Box>
        <Box
          sx={{
            fontSize: "16px",
            color: Color.secondaryTextGray,
          }}>
          Applications that you've submitted on Fetti will appear here.
        </Box>
        <Button
          sx={{
            ...SurveyButtonStyle.defaultStyling,
            ...SurveyButtonStyle.primaryColorScale,
          }}
          disableRipple
          fullWidth
          onClick={() => navigate(Slug.jobResults)}>
          Discover Your Best Matches
        </Button>
      </Stack>
    </Stack>
  );
};

export default NoApplicationsScreen;
